const getDayDateRange = (date: number | Date | null) => {
  const endDate = new Date(date || 0);
  endDate.setHours(23);
  endDate.setMinutes(59);
  endDate.setSeconds(59);
  const startDate = new Date(date || 0);
  startDate.setHours(0);
  startDate.setMinutes(0);
  startDate.setSeconds(0);

  return {
    end: endDate.getTime(),
    start: startDate.getTime(),
  };
};

export default getDayDateRange;
